import React from 'react';

import { useTournamentAppConfiguration } from "../utils/tournamentconfig/TournamentConfiguration"
import { NotificationBannerContent, checkIsBannerDismissed } from './NotificationBanner';

function Footer({ isBannerDismissed }) {
    const tournamentAppConfiguration = useTournamentAppConfiguration()
    const showBannerInFooter = isBannerDismissed !== undefined ? isBannerDismissed : checkIsBannerDismissed();

    return (
        <>
            <footer className="footer">
                <p>
                    Support: <a
                        href="mailto:FliPal@mikedg.com">FliPal@mikedg.com</a> | {tournamentAppConfiguration.copyrightMessage} |
                    FliPal &copy; {new Date().getFullYear()} | <a
                        href="https://paypal.me/mikedg0" target="_blank" rel="noopener noreferrer">Help cover hosting costs and/or tip Mike DG</a>
                </p>
            </footer>
            <footer className="footer secondary-footer">
                Hi, I'm Mike! I'm the developer behind FliPal. I'm currently seeking new opportunities (contract or full-time remote).
                <strong> Android</strong> is preferred but any development is possible.
                If you're looking for a seasoned developer, I'd love to chat!<br />
                <span className="banner-links">
                    <a href="https://mikedg.com" target="_blank" rel="noopener noreferrer" className="banner-link">Portfolio</a>
                    <span className="banner-divider">|</span>
                    <a href="https://www.linkedin.com/in/themikedg/" target="_blank" rel="noopener noreferrer" className="banner-link">LinkedIn</a>
                    <span className="banner-divider">|</span>
                    <a href="mailto:vinblau@gmail.com" className="banner-link">Email</a>
                </span>
            </footer>
            {showBannerInFooter && (
                <footer className="footer notification-footer">
                    <div className="banner-content">
                        <div className="banner-message">
                            <NotificationBannerContent />
                        </div>
                    </div>
                </footer>
            )}
        </>
    )
}

export default Footer;